// Small output helpers. The CLI's output is the only thing most users ever see of it, so "1 service" rather
// than "1 service(s)" and "9.6 MB" rather than "9812.3 KB" are worth the few lines.

/** `3 services`, `1 service`, `2 entries`. */
export function plural(count: number, singular: string, many = `${ singular }s`): string {
  return `${ count } ${ count === 1 ? singular : many }`
}

/** A size a human reads at a glance, in the largest unit that keeps it above 1. */
export function formatBytes(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB']

  let value = bytes
  let unit = 0

  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit++
  }

  return `${ unit === 0 ? value : value.toFixed(1) } ${ units[unit] }`
}

/** Hashes are shown short everywhere: the first 12 characters identify a version to a reader. */
export function shortHash(hash: string): string {
  return hash.slice(0, 12)
}
